import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { StepProgress } from 'components/shared/StepProgress/StepProgress'
import { StepButton } from './common/StepButton/StepButton'

import { ChevronLeftIcon, ChevronRightIcon } from 'components/shared/Icon/model'

import styles from './StepProgressGroup.module.scss'
import { useTabScrollIntoView } from 'hooks'

export const StepProgressGroup = ({
  activeStep,
  className,
  size,
  steps = [],
  onNextStep,
  onPreviousStep,
  onStep,
  hasActions = false,
  isNextDisabled,
  isPreviousDisabled,
}) => {
  const ref = useTabScrollIntoView(activeStep)

  return (
    <Box
      align="center"
      className={cx(styles.group, { [className]: Boolean(className) })}
    >
      {hasActions ? (
        <StepButton
          ariaLabel="previous step"
          className={styles.button}
          icon={ChevronLeftIcon}
          onClick={onPreviousStep}
          isDisabled={isPreviousDisabled}
        />
      ) : null}
      <List ariaLabel="progressGroup" className={styles.list} tagName="menu">
        {R.map(
          ({ key, label, isActive, isDisabled, isDone, isEdited }) => (
            <List.Item
              className={cx(styles.item, {
                [styles.size]: Boolean(size),
                [styles[size]]: Boolean(size),
              })}
              {...{ key }}
            >
              <StepProgress
                onClick={() => onStep(key)}
                {...{
                  label,
                  ref,
                  size,
                  isActive,
                  isDisabled,
                  isDone,
                  isEdited,
                }}
              />
            </List.Item>
          ),
          steps,
        )}
      </List>
      {hasActions ? (
        <StepButton
          ariaLabel="next step"
          className={styles.button}
          icon={ChevronRightIcon}
          onClick={onNextStep}
          isDisabled={isNextDisabled}
        />
      ) : null}
    </Box>
  )
}
